import { render } from "./Loading.vue?vue&type=template&id=0661fd9d&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=0661fd9d&lang=scss&scoped=true"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0661fd9d"]])

export default __exports__